import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Autoplay, Pagination } from "swiper";
import { lazy, Suspense, useEffect, useState } from "react";
import WelcomeHeroSlider from "components/skeleton/WelcomeHeroSlider";
import LiveTVService from "services/liveTv/LiveTVService";

const PPVAdvertiesmentCard = lazy(() => import("./PPVAdvertiesmentCard"));

function PPVAdvertiesments() {
  const [slider, setSlider] = useState<any[]>([]);
  const [isLoading, setIsLoding] = useState<any>(false);

  useEffect(() => {
    setIsLoding(true);
    const getSliderData = async () => {
      try {
        const res = await LiveTVService.getTVChannelBanner();
        // Sort the slider data by order value before setting it to state
        const sortedData = res.data.sort((a: any, b: any) => a.order - b.order);
        setSlider(sortedData);
      } catch (e) {
        console.log("getTVChannelBanner ", e);
      } finally {
        setIsLoding(false);
      }
    };

    getSliderData();
  }, []);

  return (
    <>
      {!isLoading && slider && slider?.length > 0 && (
        <Suspense fallback={<WelcomeHeroSlider />}>
          <>
            <Swiper
              navigation={false}
              modules={[Navigation, Autoplay, Pagination]}
              autoplay={{
                delay: 5000,
                disableOnInteraction: true,
              }}
              pagination={{
                clickable: true,
              }}
              className="mt-4 mb-10 mySwiper"
            >
              {slider?.map((d: any, i) => (
                <SwiperSlide key={i}>
                  <PPVAdvertiesmentCard data={d} />
                </SwiperSlide>
              ))}
            </Swiper>
          </>
        </Suspense>
      )}
      {isLoading && <WelcomeHeroSlider />}
    </>
  );
}

export default PPVAdvertiesments;
